import { api } from './client';

/**
 * One row as returned by analytics-service /metrics (proxied through
 * admin-service at /admin/analytics/metrics). NOTE: the backend returns one
 * row PER DAY for each (pageKey, username) pair and does not include the date,
 * so the dashboard aggregates these client-side over the selected range.
 */
export interface MetricRow {
  pageKey: string;
  username: string;
  views: number;
  clicks: number;
  ctr: number;            // clicks / views * 100 (percent)
  monetizationType: string; // "PPC" | "OTHER"
  cpc: number;            // cost per click (PPC only)
  revenue: number;        // clicks * cpc (PPC only)
  rpm: number;            // revenue / views * 1000
}

/**
 * High default cap on rows fetched. The backend already aggregates per
 * (page, model), so the row count is bounded by distinct pairs (it does NOT
 * grow with the date range) — this comfortably covers the full set.
 */
export const METRICS_FETCH_LIMIT = 100_000;

/**
 * Fetch aggregated metric rows for a date range (one row per page × model).
 *
 * @param from inclusive start date, "YYYY-MM-DD"
 * @param to   inclusive end date,   "YYYY-MM-DD"
 */
export const getMetrics = async (
  from: string,
  to: string,
  limit: number = METRICS_FETCH_LIMIT
): Promise<MetricRow[]> => {
  const { data } = await api.get<MetricRow[]>('/admin/analytics/metrics', {
    params: { from, to, limit }
  });
  return data;
};
